import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vendor-trans-details',
  templateUrl: './vendor-trans-details.component.html',
  styleUrls: ['./vendor-trans-details.component.css']
})
export class VendorTransDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
